import * as React from 'react'
import { Formik } from 'formik'
import { Button, Alert, FormGroup,Input } from 'reactstrap'

// import TitleInput from './TitleInput'
import ErrorMessage from './ErrorMessage'
import { I18n } from 'react-redux-i18n'
import PhoneInput from 'react-phone-input-2'
import es from 'react-phone-input-2/lang/es.json'
import Nixi1Spinner from 'components/Nixi1Spinner'

const StepTwo = (props) => {
  const { errorGeneral } = props
  const MAP_FIELD_ERRORS = {
    companyName: I18n.t('form_input_company_error'),
    nif: I18n.t('form_input_company_nif_error'),
    phoneCode: I18n.t('form_input_phone_code_error')
  }

  const initialValues = props.initialValues
  //const [errors, setErrors] = React.useState({})
  const [registerType, setRegisterType] = React.useState('company')
  const [validateStatus, setValidateStatus] = React.useState(false)

  const validateFields = (values) => {
    const errors = {}
    if (registerType === 'company' && values.companyName === '') {
      errors.companyName = MAP_FIELD_ERRORS.companyName
    }
    if (values.nif === '') {
      errors.nif = MAP_FIELD_ERRORS.nif
    }
    if (!validateStatus) {
      setValidateStatus(true)
    }
    return errors
  }

  const submitFields = (values) => {
    values.registerType = registerType
    props.goToStepThree(values)
  }

  const backStep = (values) => {
    if (props.backStep) {
      props.backStep(values)
    }
  }

  const registerTypeChange = (event) => {
    setRegisterType(event.target.value)
  }

  React.useEffect(() => {
    const errors = {}
    for (const key in props.httpErrors) {
      errors[key] = MAP_FIELD_ERRORS[key]
    }

    //setErrors(errors)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.httpErrors])

  return (
    <Formik initialValues={initialValues} validate={validateFields} onSubmit={submitFields} validateOnChange={validateStatus}>
      {({ values, handleChange, handleSubmit, errors }) => (
        <div className='form-window'>
          <div className="back-container">
            <img className='btn-back' onClick={() => backStep(values)} src="img/icons/back-arrow-signup.svg" alt='back-arrow.svg' />
          </div>
          <div className='header-two'>
            <div className='title'>{I18n.t('signup_step_two_form_title')}</div>
          </div>

          {
            (errorGeneral) &&
            <div className="signup-operator-alert-token">
              <Alert color='danger'>{I18n.t('signup_generic_error')}</Alert>
            </div>
          }

          <div className='form'>
            <div className="login-container">
              <div className="group-type-register">
                <div className="nx-radio">
                  <input type="radio" id="radio-type-company" name="registerType" value="company" onChange={registerTypeChange} checked={registerType === 'company'}></input>
                  <label htmlFor="radio-type-company">{I18n.t('dashboard_company')}</label>
                </div>

                <div className="nx-radio">
                  <input type="radio" id="radio-type-person" name="registerType" value="person" onChange={registerTypeChange} checked={registerType === 'person'}></input>
                  <label htmlFor="radio-type-person">{I18n.t('signup_step_two_form_person_title')}</label>
                </div>
              </div>

              {registerType === 'company' && (
                <div className="login-form">
                  <label htmlFor="companyName">{I18n.t("dashboard_company-name")}<span className="required">*</span></label>
                  <input
                    type="string"
                    name="companyName"
                    className="email"
                    id="companyName"
                    onChange={handleChange}
                    value={values.companyName}
                    required
                  />
                </div>
              )}
              {/* <TitleInput title={I18n.t('dashboard_company-name')} name='companyName' handleChange={handleChange} value={values.companyName} /> } */}
              {registerType === 'company' && errors.companyName ? <ErrorMessage text={errors.companyName} /> : null}
              <div className="login-form">
                <label htmlFor="nif">{I18n.t("signup_step_two_form_input_nif_title")}<span className="required">*</span></label>
                <input
                  type="string"
                  name="nif"
                  id="nif"
                  className="email"
                  onChange={handleChange}
                  value={values.nif}
                  required
                />
              </div>
              {/* <TitleInput title={I18n.t('signup_step_two_form_input_nif_title')} name='nif' handleChange={handleChange} value={values.nif} /> */}
              {errors.nif ? <ErrorMessage text={errors.nif} /> : null}

              <div className='title-input-container input-phone'>
                <FormGroup>
                  <div className='title-input-text'>{I18n.t('signup_step_two_form_input_phone_title')}</div>
                  <PhoneInput
                    id='user_phone'
                    localization={es}
                    inputClass={`p-2 pl-5 border-primary w-100 phone_input`}
                    buttonClass='code_phone_btn'
                    country='es'
                    autoFormat
                    enableSearch
                    value={`${values.phoneCode || ''}${values.phone || ''}`}
                    onChange={(value, country) => {
                      const phone = value.slice(country.dialCode.length)
                      if (country.dialCode !== values.phoneCode) {
                        handleChange({ target: { name: 'phoneCode', value: `+${country.dialCode}` } })
                      }

                      if (phone !== values.phone) {
                        handleChange({ target: { name: 'phone', value: phone } })
                      }
                    }}
                  />
                  <Input hidden invalid={!!errors['phoneCode']} />
                </FormGroup>
              </div>
            </div>
          </div>
          <div className='footer-two'>
            <Button disabled={props.loadingForm} className='submit-button' onClick={handleSubmit}>
              {
                props.loadingForm ? <Nixi1Spinner height='1rem' width='1rem'/> : <div>{I18n.t('dashboard_continue')}</div>
              }
            </Button>
          </div>
        </div>
      )}
    </Formik>
  )
}

export default StepTwo
